import { Instance, types } from 'mobx-state-tree'
import '../../ieConfig/MobxConfig'

const FoodCard = types.model('FoodCard', {
  id: types.identifier,
  name: types.optional(types.string, ''),
  accountNumber: types.optional(types.string, ''),
  logo: types.optional(types.string, ''),
  isPopular: types.optional(types.boolean, false),
  rank: types.optional(types.number, 0),
  paymentType: types.optional(types.string, 'Bank'),
  token: types.optional(types.string, ''),
})

export type FoodCardType = Instance<typeof FoodCard>
export { FoodCard }
